import React, { Component } from 'react';
import './primary-button.css';

export default class PrimaryButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <button className="rdp-react-template-component-primary-button" onClick={() => this.props.onClick && this.props.onClick()}>
        {this.props.icon &&
          <span className={`rdp-react-template-component-primary-button-icon ${this.props.icon}`}></span>
        }
        <span className="rdp-react-template-component-primary-button-label" style={{color: this.props.color || "#EBEBEB"}}>{this.props.label}</span>
      </button>
    );
  }
}
